export default __webpack_public_path__ + "static/media/5.90313a3c.png";